import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import { Form, Typography, Table, Button, Input, Icon, Modal, notification } from 'antd';
import { withTranslation } from 'react-i18next';
import adminI18n from '../../i18n/adminI18n';
import AddCircleIcon from '@material-ui/icons/AddCircle';
import { green } from '@material-ui/core/colors';
import 'antd/dist/antd.css';
import Highlighter from 'react-highlight-words';
import ApiCaller from '../../../utils/api-caller';

const { Title } = Typography;

@inject(
    'templateStore'
)
@observer
class TemplateList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            searchText: '',
            searchedColumn: '',
        }
    }

    componentDidMount() {
    }

    createClicked = () => {
        this.props.templateStore.initCreate();
    }

    updateClicked = id => {
        this.props.templateStore.initUpdate(id);
    }

    removeClicked = id => {
        const { t } = this.props;
        this.props.templateStore.deleteTemplate(id).then(resp => {
            if (!resp.isError) {
                notification['success']({
                    message: t('Success'),
                    description: t('Template is successfully deleted.'),
                    duration: 1
                });
                this.props.templateStore.initTemplate();
            } else {
                notification['error']({
                    message: t('Failed'),
                    description: resp.error,
                    duration: 5
                });
            }
        });
    }

    activatingTemplateClicked = id => {
        const { t } = this.props;
        this.props.templateStore.activateTemplate(id).then(resp => {
            if (!resp.isError) {
                notification['success']({
                    message: t('Success'),
                    description: t('Template is successfully activated.'),
                    duration: 1
                });
                this.props.templateStore.initTemplate();
            } else {
                notification['error']({
                    message: t('Failed'),
                    description: resp.error,
                    duration: 5
                });
            }
        });
    }

    deleteClicked = id => {
        const { t } = this.props;
        Modal.confirm({
            title: t('Remove Template'),
            content: t('Are you sure to remove template?'),
            okText: t('Remove'),
            cancelText: t('Cancel'),
            onOk: () => this.removeClicked(id)
        });
    }

    activateClicked = id => {
        const { t } = this.props;
        Modal.confirm({
            title: t('Activate this Template'),
            content: t('Are you sure to set this template active?'),
            okText: t('Yes'),
            cancelText: t('Cancel'),
            onOk: () => this.activatingTemplateClicked(id)
        });
    }

    exportClicked = (id) => {
        ApiCaller.Exports.TemplateById(id).then(resp => {
            const jsonData = JSON.stringify(resp.templateSetting, null, 2);
            const blob = new Blob([jsonData], { type: 'application/json' });
            const url = URL.createObjectURL(blob);

            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `${resp.name}.json`);
            document.body.appendChild(link);
            link.click();

            // Bersihkan URL objek setelah selesai
            URL.revokeObjectURL(url);
            document.body.removeChild(link);
        });
    }

    getColumns = () => {
        const { t } = this.props;
        return [
            {
                title: t('Template'),
                dataIndex: 'name',
                key: 'name',
                width: '40%',
                ...this.getColumnSearchProps('name')
            },
            {
                title: t('Active'),
                dataIndex: 'isSelected',
                key: 'isSelected',
                width: '20%',
                render: isSelected => (
                    <span>{isSelected ? t('Yes') : t('No')}</span>
                )
            },
            {
                title: t('Action'),
                dataIndex: 'id',
                key: 'action',
                width: '40%',
                render: (id, data) => (
                    <span>
                        <Button onClick={() => this.updateClicked(id)} type='primary' style={{ margin: 2 }}>
                            {t('Edit')}
                        </Button>
                        <Button onClick={() => this.deleteClicked(id)} disabled={data.name === 'DEFAULT'} type='danger' style={{ margin: 2 }}>
                            {t('Delete')}
                        </Button>
                        <>
                            <Button onClick={() => this.activateClicked(id)} disabled={data.isSelected} type='default' style={{ margin: 2 }}>
                                {t('Activate')}
                            </Button>
                        </>
                        <Button onClick={() => this.exportClicked(id)} type='link' style={{ margin: 2 }}>
                            {t('Download')}
                        </Button>
                    </span>
                ),
            },
        ]
    }

    getColumnSearchProps = dataIndex => {
        const { t } = this.props;
        return ({
            filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
                <div style={{ padding: 8 }}>
                    <Input
                        ref={node => {
                            this.searchInput = node
                        }}
                        placeholder={t('Search {{dataIndex}}', { dataIndex })}
                        value={selectedKeys[0]}
                        onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                        onPressEnter={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
                        style={{ width: 188, marginBottom: 8, display: 'block' }}
                    />
                    <Button
                        type='primary'
                        onClick={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
                        icon='search'
                        size='small'
                        style={{ width: 90, marginRight: 8 }}
                    >
                        {t('Search')}
                    </Button>
                    <Button onClick={() => this.handleReset(clearFilters)} size='small' style={{ width: 90 }}>
                        {t('Reset')}
                    </Button>
                </div>
            ),
        filterIcon: filtered => (
            <Icon type='search' style={{ color: filtered ? '#1890ff' : undefined }} />
        ),
        onFilter: (value, record) =>
            record[dataIndex]
                .toString()
                .toLowerCase()
                .includes(value.toLowerCase()),
        onFilterDropdownVisibleChange: visible => {
            if (visible) {
                setTimeout(() => this.searchInput.select())
            }
        },
        render: text =>
            this.state.searchedColumn === dataIndex ? (
                <Highlighter
                    highlightStyle={{ padding: 0 }}
                    searchWords={[this.state.searchText]}
                    autoEscape
                    textToHighlight={text.toString()}
                />
            ) : (
                text
            ),
        });
    }

    handleSearch = (selectedKeys, confirm, dataIndex) => {
        confirm()
        this.setState({
            searchText: selectedKeys[0],
            searchedColumn: dataIndex,
        });
    };

    handleReset = clearFilters => {
        clearFilters()
        this.setState({ searchText: '' })
    }

    render() {
        const { t } = this.props;
        const {
            templates
        } = this.props.templateStore;

        return (
            <React.Fragment>
                <Form layout='horizontal'>
                    <div style={{ marginBottom: 20 }}>
                        <Title level={3} style={{ width: '80%', position: 'relative', float: 'left' }}>{t('Template List')}</Title>
                        <div style={{ textAlign: 'right' }}>
                            <button type='button' style={{ border: 'none', background: 'none', cursor: 'pointer' }} onClick={this.createClicked}>
                                <AddCircleIcon style={{ color: green[500], fontSize: 45 }} />
                            </button>
                        </div>
                    </div>
                    <Table columns={this.getColumns()} dataSource={templates} />
                </Form>
            </React.Fragment>
        )
    }
}

export default withTranslation(undefined, { i18n: adminI18n })(TemplateList);